module.exports = __webpack_public_path__ + "static/img/banner_img2.52e7f7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_img2.png
// module id = pz1z
// module chunks = 2